import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export const multiProductFilterService = {
    async getMetafields() {
        const response = await axios.get(`${API_URL}/app/multi-product-filter`);
        return response.data;
    },

    async getCategories(query) {
        const response = await axios.post(`${API_URL}/app/multi-product-filter/categories`, query, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    async searchProducts(requestData) {
        const response = await axios.post(`${API_URL}/app/multi-product-filter`, requestData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },

    async getSnapshotPage(snapshotId, page = 1, limit = 10) {
        const response = await axios.get(`${API_URL}/app/multi-product-filter/snapshot/${snapshotId}`, {
            params: { page, limit },
            timeout: 30000,
        });
        return response.data;
    },

    async searchSnapshotProducts(snapshotId, { page = 1, limit = 10, search, minPrice, maxPrice, sortBy, sortDirection }) {
        const response = await axios.get(`${API_URL}/app/multi-product-filter/snapshot/${snapshotId}/search`, {
            params: {
                page,
                limit,
                ...(search && { search }),
                ...(minPrice !== null && minPrice !== undefined && { minPrice }),
                ...(maxPrice !== null && maxPrice !== undefined && { maxPrice }),
                ...(sortBy && { sortBy }),
                ...(sortDirection && { sortDirection }),
            },
            timeout: 30000,
        });
        return response.data;
    },
};
